<template>
  <section
    id="contact"
    class="contact-section"
  >
    <div class="section-container">
      <!-- Section Header -->
      <div class="section-header">
        <span class="section-badge">Get In Touch</span>
        <h2 class="section-title">
          Contact Us
        </h2>
        <p class="section-subtitle">
          Have questions or need assistance? We're here to help.
        </p>
      </div>

      <!-- Contact Grid -->
      <div class="contact-grid">
        <!-- Contact Info -->
        <div class="contact-info">
          <div class="info-card">
            <div class="info-icon green">
              <i class="fas fa-map-marker-alt" />
            </div>
            <div class="info-content">
              <h4>Visit Us</h4>
              <p>Office of Student Affairs & Services</p>
              <p>2nd Floor, Main Building</p>
              <p>Northeastern College</p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon yellow">
              <i class="fas fa-phone-alt" />
            </div>
            <div class="info-content">
              <h4>Call Us</h4>
              <p>(054) 123-4567</p>
              <p>Local: 201, 202</p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon green">
              <i class="fas fa-envelope" />
            </div>
            <div class="info-content">
              <h4>Email Us</h4>
              <p>osas@ncf.edu.ph</p>
              <p>studentaffairs@ncf.edu.ph</p>
            </div>
          </div>

          <div class="info-card">
            <div class="info-icon yellow">
              <i class="fas fa-clock" />
            </div>
            <div class="info-content">
              <h4>Office Hours</h4>
              <p>Monday - Friday</p>
              <p>8:00 AM - 5:00 PM</p>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="contact-form-card">
          <h3>Send us a Message</h3>
          <form
            class="contact-form"
            @submit.prevent="$emit('submit')"
          >
            <div class="form-row">
              <div class="form-group">
                <label>Full Name</label>
                <input
                  v-model="form.name"
                  type="text"
                  placeholder="Your full name"
                  required
                >
              </div>
              <div class="form-group">
                <label>Email Address</label>
                <input
                  v-model="form.email"
                  type="email"
                  placeholder="your.email@example.com"
                  required
                >
              </div>
            </div>

            <div class="form-group">
              <label>Subject</label>
              <input
                v-model="form.subject"
                type="text"
                placeholder="What is this about?"
                required
              >
            </div>

            <div class="form-group">
              <label>Message</label>
              <textarea
                v-model="form.message"
                rows="4"
                placeholder="Write your message here..."
                required
              />
            </div>

            <button
              type="submit"
              class="btn-submit"
              :disabled="submitting"
            >
              <i :class="['fas', submitting ? 'fa-spinner fa-spin' : 'fa-paper-plane']" />
              {{ submitting ? 'Sending...' : 'Send Message' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '../../../assets/css/landing/sections/contact.css'

export default {
  name: 'ContactSection',
  props: {
    form: {
      type: Object,
      default: () => ({
        name: '',
        email: '',
        subject: '',
        message: ''
      })
    },
    submitting: {
      type: Boolean,
      default: false
    }
  }
}
</script>
